import { Input } from '@/shared/components/ui/input'
import { Textarea } from '@/shared/components/ui/textarea'
import { CharacterVariant } from '@storyverse/shared'
import { FormField } from './FormField'
import React from 'react'

interface VariantPhysicalTabProps {
    variant: CharacterVariant
    updateVariant: (id: string, updates: Partial<CharacterVariant>) => void
}

export const VariantPhysicalTab: React.FC<VariantPhysicalTabProps> = ({ variant, updateVariant }) => {
    return (
        <div className="space-y-6 pt-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <FormField label="Height" helperText={'Height (e.g., 5\'10", 178cm).'}>
                    <Input value={variant.height || ''} onChange={e => updateVariant(variant.id, { height: e.target.value })} className="h-10" />
                </FormField>
                <FormField label="Weight" helperText="Weight (e.g., 160 lbs, 72kg).">
                    <Input value={variant.weight || ''} onChange={e => updateVariant(variant.id, { weight: e.target.value })} className="h-10" />
                </FormField>
                <FormField label="Body" helperText="Body type (e.g., Athletic, Slim).">
                    <Input value={variant.body_type || ''} onChange={e => updateVariant(variant.id, { body_type: e.target.value })} className="h-10" />
                </FormField>
                <FormField label="Eyes" helperText="Eye color and shape.">
                    <Input value={variant.eye_color || ''} onChange={e => updateVariant(variant.id, { eye_color: e.target.value })} className="h-10" />
                </FormField>
                <FormField label="Hair" helperText="Hair color, style, and length.">
                    <Input value={variant.hair || ''} onChange={e => updateVariant(variant.id, { hair: e.target.value })} className="h-10" />
                </FormField>
                <FormField label="Beard Style" helperText="Style of the beard.">
                    <Input value={variant.beard_style || ''} onChange={e => updateVariant(variant.id, { beard_style: e.target.value })} className="h-10" />
                </FormField>
                <FormField label="Moustache" helperText="Style of the moustache.">
                    <Input value={variant.moustache || ''} onChange={e => updateVariant(variant.id, { moustache: e.target.value })} className="h-10" />
                </FormField>
                <FormField label="Skin" helperText="Skin tone and complexion.">
                    <Input value={variant.skin_tone || ''} onChange={e => updateVariant(variant.id, { skin_tone: e.target.value })} className="h-10" />
                </FormField>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <FormField label="Voice" helperText="Tone, pitch, accent.">
                    <Input value={variant.voice || ''} onChange={e => updateVariant(variant.id, { voice: e.target.value })} className="h-10" />
                </FormField>
                <FormField label="Style" helperText="Clothing and aesthetics.">
                    <Input value={variant.clothing_style || ''} onChange={e => updateVariant(variant.id, { clothing_style: e.target.value })} className="h-10" />
                </FormField>
            </div>
            <FormField label="Marks & Disabilities" helperText="Scars, tattoos, or physical limitations.">
                <Textarea
                    value={variant.distinctive_marks || variant.disability || ''}
                    onChange={e => updateVariant(variant.id, { distinctive_marks: e.target.value })}
                    rows={2}
                    className="bg-background border-primary/10 transition-all focus:border-primary/40 text-sm leading-relaxed"
                />
            </FormField>
        </div>
    )
}
